export default {
      id: "water-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#water-usage",
      toString: function () {
        return this.url;
      }
    }